/** Field definitions for the Orders grid filter. `getValue` reads Airtable field names. */
function text(record, ...keys) {
    const fields = record?.fields || {};
    for (const key of keys) {
        if (fields[key] != null && fields[key] !== "") return fields[key];
    }
    return "";
}

export const ORDER_FILTER_FIELDS = [
    { id: "orderNumber", label: "Order Number", type: "text", getValue: (row) => text(row, "Order Number", "Walmart Customer Order ID") },
    { id: "channel", label: "Selling channel", type: "select", options: ["eBay", "Walmart"], getValue: (row) => text(row, "Selling channel") },
    { id: "status", label: "Order Status", type: "text", getValue: (row) => text(row, "Order Status") },
    { id: "platformStatus", label: "Platform Status", type: "text", getValue: (row) => text(row, "Platform Status") },
    { id: "orderDate", label: "Order Creation Date", type: "date", getValue: (row) => text(row, "Order Creation Date") },
    { id: "itemId", label: "Item ID", type: "text", getValue: (row) => text(row, "Item ID", "SKU Helper") },
    { id: "itemTitle", label: "Item Title", type: "text", getValue: (row) => text(row, "Item Title") },
    { id: "buyerName", label: "Buyer Name", type: "text", getValue: (row) => text(row, "Buyer Name") },
    { id: "city", label: "Ship to city", type: "text", getValue: (row) => text(row, "Ship to city") },
    { id: "state", label: "Ship to state", type: "text", getValue: (row) => text(row, "Ship to province/region/state") },
    { id: "zip", label: "Ship to zip", type: "text", getValue: (row) => text(row, "Ship to zip") },
    { id: "quantity", label: "Quantity", type: "number", getValue: (row) => row?.fields?.["Quantity"] },
    { id: "itemPrice", label: "Item price", type: "number", getValue: (row) => row?.fields?.["Item price"] },
    { id: "gross", label: "Gross amount", type: "number", getValue: (row) => row?.fields?.["Gross amount"] },
    { id: "shippingService", label: "Shipping Service", type: "text", getValue: (row) => text(row, "Shipping Service") },
    { id: "tracking", label: "Tracking Number", type: "text", getValue: (row) => text(row, "Shipping Tracking Number") },
];
